/**
 * Boots Featurebase Messenger when VITE_FEATUREBASE_APP_ID is set.
 * Free plan: live chat only (not the paid Feedback widget).
 *
 * Pass a minimal boot payload — Strict Mode remounts call `identify` with the
 * same object, and Featurebase rejects non-identity fields (e.g. theme).
 */
import { useAuthStore } from "@/modules/auth/store";
import { FeaturebaseProvider as SdkProvider } from "featurebase-js/react";
import type { ReactNode } from "react";

const APP_ID = import.meta.env.VITE_FEATUREBASE_APP_ID?.trim() ?? "";

/** Site-wide Featurebase shell — no-op when App ID is unset. */
export function FeaturebaseRoot({ children }: { children: ReactNode }) {
  const featurebaseJwt = useAuthStore((s) => s.user?.featurebaseJwt);
  const initialized = useAuthStore((s) => s.initialized);
  const jwt =
    typeof featurebaseJwt === "string" && featurebaseJwt.length > 0
      ? featurebaseJwt
      : undefined;

  return (
    <>
      {APP_ID && initialized ? (
        <SdkProvider
          appId={APP_ID}
          {...(jwt ? { featurebaseJwt: jwt } : {})}
        >
          {null}
        </SdkProvider>
      ) : null}
      {children}
    </>
  );
}
